export type MobilePlatformPageId =
  "dashboard" | "stopwatch" | "planner" | "marketplace" | "stable";

function platformPath(pathname: string, locale: string): string {
  const normalizedPath = pathname.replace(/\/+$/u, "") || "/";
  const localePrefix = `/${locale}`;
  if (normalizedPath === localePrefix) return "/";
  return normalizedPath.startsWith(`${localePrefix}/`)
    ? normalizedPath.slice(localePrefix.length)
    : normalizedPath;
}

export function mobilePlatformPageId(
  pathname: string,
  locale: string,
): MobilePlatformPageId | null {
  const path = platformPath(pathname, locale);
  if (path === "/dashboard") return "dashboard";
  if (path === "/stopwatch" || path.startsWith("/stopwatch/")) {
    return "stopwatch";
  }
  if (path === "/planner" || path.startsWith("/planner/")) return "planner";
  if (path === "/marketplace" || path.startsWith("/marketplace/")) {
    return "marketplace";
  }
  if (
    path === "/stable" ||
    path.startsWith("/stable/") ||
    path === "/hire" ||
    path.startsWith("/hire/")
  ) {
    return "stable";
  }
  return null;
}
